/**
 * Reusable section heading.
 * Headline at top, then a small label below (the `.underline-label`
 * class auto-renders a tiny gold accent line BELOW the label text).
 */
export default function SectionHeading({ title, subtitle, alignment = "left", tone = "dark" }) {
  const textColor = tone === "light" ? "text-white" : "text-[#1c1c1c]";
  const align = alignment === "center" ? "items-center text-center" : "items-start";
  return (
    <div className={`flex flex-col ${align}`}>
      <h2 className={`font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] max-w-3xl ${textColor}`}>
        {title}
      </h2>
      {subtitle && (
        <span className={`mt-7 underline-label ${alignment === "center" ? "center" : ""}`}>
          {subtitle}
        </span>
      )}
    </div>
  );
}
